import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-course-icon"
export default class extends Controller {
  static targets = ["icon"];

  toggle() {
    const targetId = this.element.getAttribute("data-accordion-target");
    const targetElement = document.querySelector(targetId);
    const expanded = this.element.getAttribute("aria-expanded") === "true";

    this.element.setAttribute("aria-expanded", !expanded);

    if (targetElement) {
      targetElement.classList.toggle("open");
    }

    this.iconTarget.classList.toggle("-rotate-90");
  }
}
